export default __webpack_public_path__ + "static/media/micro-credit.7898759a.png";